import React from 'react'
import { useTranslation } from 'react-i18next'

import { TipBulb } from 'svg'

import styles from './HeaderTip.module.scss'

const HeaderTip = () => {
    const { t } = useTranslation()

    return (
        <div className={styles.headerTip}>
            <TipBulb />
            <p className={styles.note}>
                {t('Add a lead form to your wheel to collect leads and see the results of each user')}
            </p>
        </div>
    )
}

export default HeaderTip
